export const ANDROID_NOTIFICATION_CHANNEL_ID = 'default';
export const ANDROID_NOTIFICATION_CHANNEL_NAME = 'StadtLand.Funk Notifications';
